// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutDynamicZone_container__2YPN3","textSection":"LayoutDynamicZone_textSection__12rKH","image":"LayoutDynamicZone_image__1v7ne"};